import React, { useState } from "react";
import { ReactSVG } from "react-svg";
import upArrow from "../icon/dashboard/Arrow/IOS/Up.svg";
import downArrow from "../icon/dashboard/Arrow/IOS/Down.svg";
import { setSVGColor } from "../SVGHelper";
import "../style/typography.scss";
import "../style/card.scss";

function Accordion({ title, icon, children, defaultOpen: initiallyOpen = true }) {
    const [opened, setIsOpen] = useState(initiallyOpen);
    const arrowVectorPath = opened ? upArrow : downArrow;

    return (
        <div className="w-full">
            <div className="px-4 flex items-center justify-between cursor-pointer" onClick={() => setIsOpen(!opened)}>
                <div className="flex items-center">
                    {icon && (
                        <ReactSVG
                            src={icon}
                            alt="icon"
                            className="mr-5"
                            beforeInjection={setSVGColor("var(--colors-main-2)")}
                        />
                    )}
                    <p className="paragraph-4-semibold" style={{ color: "var(--colors-main-2)" }}>
                        {title}
                    </p>
                </div>
                <ReactSVG src={arrowVectorPath} beforeInjection={setSVGColor("var(--colors-main-2)")} />
            </div>
            {opened && <div className="my-3 card">{children}</div>}
        </div>
    );
}

export default Accordion;
